import { apiClient } from './client';

export interface TelegramGroup {
  chatId:    string;
  tenantId:  string;
  ranchoId:  string;
  loteId?:   string | null;
  label:     string;
  linkedBy:  string;
  linkedAt:  number;
  active:    boolean;
  language?: 'es' | 'en' | 'zh';
  /** Rol de enfoque: el bot actúa en el grupo con las herramientas de ese rol (nunca con más permisos). */
  role?:     string | null;
  /** Propósito (copia de supervisión). Ausente = CAPTURA. */
  proposito?: 'CAPTURA' | 'SUPERVISION';
  /** Modo de captura. Ausente = TODO. */
  modoCaptura?: 'TODO' | 'SOLO_MENCION';
  /** Alcance de un grupo de supervisión. */
  alcance?: 'ROL' | 'RANCHO' | null;
  /** Rol de un grupo de supervisión por rol. */
  rol?: string | null;
}

export interface TelegramGroupInput {
  chatId:   string;
  ranchoId: string;
  loteId?:  string | null;
  label:    string;
  language?: 'es' | 'en' | 'zh';
}

export const fetchTelegramGroups = async (): Promise<TelegramGroup[]> =>
  (await apiClient.get('/api/telegram-groups')).data;

export const createTelegramGroup = async (input: TelegramGroupInput): Promise<TelegramGroup> =>
  (await apiClient.post('/api/telegram-groups', input)).data;

export const updateTelegramGroup = async (
  chatId: string,
  input: Partial<Pick<TelegramGroup, 'ranchoId' | 'loteId' | 'label' | 'active' | 'language' | 'role'>>,
): Promise<void> =>
  (await apiClient.patch(`/api/telegram-groups/${chatId}`, input)).data;

/** Borra el vínculo del grupo (el grupo de Telegram en sí no se toca). */
export const deleteTelegramGroup = async (chatId: string): Promise<void> =>
  (await apiClient.delete(`/api/telegram-groups/${chatId}`)).data;
